export const iconFontAwesomeSciencefictionUserAstronaut = (
	<i className="fa-solid fa-user-astronaut"></i>
);
